import { useState, useCallback } from 'react';
import { AudioUploadResponse } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';
import { toast } from 'sonner';

export function useAudioUpload(jobId: string, candidateId: string, interviewId: string) {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const uploadAudio = useCallback(async (file: File): Promise<void> => {
    setIsUploading(true);
    setProgress(0);
    try {
      // 1. Solicitar URL pré-assinada
      const { uploadUrl, s3Key } = await apiClient.post<AudioUploadResponse>(
        `/jobs/${jobId}/candidates/${candidateId}/interviews/${interviewId}/audio`,
        { fileName: file.name, contentType: file.type, fileSize: file.size }
      );

      // 2. Upload direto para S3
      setProgress(30);
      const uploadResponse = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: { 'Content-Type': file.type },
      });

      if (!uploadResponse.ok) {
        throw new Error('Falha no upload do áudio para S3');
      }

      setProgress(70);

      // 3. Confirmar upload
      await apiClient.post(
        `/jobs/${jobId}/candidates/${candidateId}/interviews/${interviewId}/audio/confirm`,
        { s3Key }
      );

      setProgress(100);
      toast.success('Áudio enviado com sucesso. Transcrição iniciada.');
    } catch (err) {
      toast.error('Erro ao enviar áudio. Tente novamente.');
      throw err;
    } finally {
      setIsUploading(false);
    }
  }, [jobId, candidateId, interviewId]);

  return { uploadAudio, isUploading, progress };
}
